export { OracleGreetingCard } from './OracleGreetingCard'
export { resolveGreetingName } from './resolveGreetingName'
export type { ResolveGreetingName } from './resolveGreetingName'
